import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="thumbs_up_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M908.8 430.08A128 128 0 0 0 810.667 384h-194.56L640 322.987A176.213 176.213 0 0 0 474.027 85.333a42.667 42.667 0 0 0-38.827 25.174L313.6 384H213.333a128 128 0 0 0-128 128v298.667a128 128 0 0 0 128 128H756.48a128 128 0 0 0 125.867-104.96l54.186-298.667A128 128 0 0 0 908.8 430.08zM298.667 853.333h-85.334a42.667 42.667 0 0 1-42.666-42.666V512a42.667 42.667 0 0 1 42.666-42.667h85.334v384zM853.333 519.68l-54.186 298.667a42.667 42.667 0 0 1-42.667 34.986H384V435.627l116.053-261.12a90.027 90.027 0 0 1 58.88 118.613l-22.613 61.013a85.333 85.333 0 0 0 79.787 115.2h194.56a42.667 42.667 0 0 1 32.853 15.36 42.667 42.667 0 0 1 9.813 34.987z"
    />
  </svg>
);
export default SvgThumbsUpIcon;
